module.exports = __webpack_public_path__ + "img/baseline-keyboard_arrow_up-24px.24a93bb6.svg";